import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cartSlice';
import accountReducer from './accountSlice';

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    account: accountReducer,
  },
});
